export default (value) => {
    let i = value.length;
    let hash = 0;

    while (i > 0) {
        hash = (hash << 5) - hash + value.charCodeAt(--i);
        hash &= hash;
    }

    return new Uint32Array([hash])[0].toString(36);
};
